import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import type { Customer } from '../customer';
import { sizesByOrders } from '../customer.utils';

/** One row of the customer list. */
@Component({
  selector: 'app-customer-item',
  imports: [AvatarComponent, CurrencyPipe, DatePipe, DecimalPipe],
  templateUrl: './customer-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class CustomerItem {
  readonly customer = input.required<Customer>();

  protected readonly spent = computed(() => this.customer().totalSpentCents / 100);
  protected readonly lastOrder = computed(() => this.customer().lastOrderAt?.toDate());

  /** The size this customer printed most often, by number of orders. */
  protected readonly favoriteSize = computed(() => sizesByOrders(this.customer().bySize)[0]?.label ?? null);
}
